import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { DashboardDemoComponent } from './demo/view/dashboarddemo.component';
import { SampleDemoComponent } from './demo/view/sampledemo.component';
import { FormsDemoComponent } from './demo/view/formsdemo.component';
import { DataDemoComponent } from './demo/view/datademo.component';
import { PanelsDemoComponent } from './demo/view/panelsdemo.component';
import { OverlaysDemoComponent } from './demo/view/overlaysdemo.component';
import { MenusDemoComponent } from './demo/view/menusdemo.component';
import { MessagesDemoComponent } from './demo/view/messagesdemo.component';
import { MiscDemoComponent } from './demo/view/miscdemo.component';
import { EmptyDemoComponent } from './demo/view/emptydemo.component';
import { ChartsDemoComponent } from './demo/view/chartsdemo.component';
import { FileDemoComponent } from './demo/view/filedemo.component';
import { DocumentationComponent } from './demo/view/documentation.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { HomeLayoutComponent } from './layouts/home-layout/home-layout.component';
import { HomeComponent } from './learn/home/home.component';
import { PageNotFoundComponent } from './learn/view/page-not-found/page-not-found.component';
import { LoginComponent } from './login/login.component';
import { AuthGaurd } from './login/services/auth-gaurd.service';

export const routes: Routes = [

    {
        path: '',                       // {1}
        component: HomeLayoutComponent,
        // canActivate: [AuthGaurd],       // {2}
        children: [
            {
                path: '',
                component: HomeComponent   // {3}
            },
            {
                path: "learn-angular", loadChildren: () => import("./learn/learn.module").then(m => m.LearnModule)
            },
            {
                path: "learn-flexbox", loadChildren: () => import("./flexbox/flexbox.module").then(m => m.FlexboxModule)
            },
            { path: '', component: DashboardDemoComponent },
            { path: 'sample', component: SampleDemoComponent },
            { path: 'forms', component: FormsDemoComponent },
            { path: 'data', component: DataDemoComponent },
            { path: 'panels', component: PanelsDemoComponent },
            { path: 'overlays', component: OverlaysDemoComponent },
            { path: 'menus', component: MenusDemoComponent },
            { path: 'messages', component: MessagesDemoComponent },
            { path: 'misc', component: MiscDemoComponent },
            { path: 'empty', component: EmptyDemoComponent },
            { path: 'charts', component: ChartsDemoComponent },
            { path: 'file', component: FileDemoComponent },
            { path: 'documentation', component: DocumentationComponent },
            { path: '404', component: PageNotFoundComponent },
        ]
    },
    {
        path: '',
        component: LoginLayoutComponent, // {4}
        children: [
            {
                path: 'login',
                component: LoginComponent   // {5}
            }
        ]
    }
];

export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' });
